export default __webpack_public_path__ + "static/untitled-sans-web-light-28c97c5a4bb044aca0f46de88c044521.woff";